import { render, staticRenderFns } from "./StaffActive.vue?vue&type=template&id=2874db2a&scoped=true&"
import script from "./StaffActive.vue?vue&type=script&lang=js&"
export * from "./StaffActive.vue?vue&type=script&lang=js&"
import style0 from "./StaffActive.vue?vue&type=style&index=0&id=2874db2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874db2a",
  null
  
)

export default component.exports